<template>
  <div class="baseNewsRight">
    <div class="baseNewsTitle">
      <span href="#" class="contentTitle"  @click="back()" v-for="(item,index) in navigationList" :key="index">
        {{langes==0?(item.barName?item.barName:item[parentEle.title]):(item.barName?item.barEngName:item[parentEle.title+'En'])}}
        <span
          v-if="index!=navigationList.length-1"
       >></span> 
      </span>
      <!-- 显示标题内容--->
       <span href="#" v-if="isShowTitle"  @click="back()">
        > {{barTitle}}
      </span>
    </div>
    <div class="baseNewsContent" v-if="!detailShow">
      <div style="height:650px;">
      <ul>
        <li v-for="(item,index) in newsList" :key="index" @click="newsDetail(item)">
          <div class="timeDive">
              <span class="createTime">{{item.createTime | formatDateToMonth}}</span>
              <span class="createTimeYear">{{item.createTime | formatDateToYear}}</span>
          </div>
           <div class="timeDive">
              <span class="newsTitleSpan">{{item.newsTitle}}</span>
              <span class="newsDetails" v-html="ellipsis(item.newsContent)"></span>
           </div>
        </li>
      </ul>
        </div>
      <div class="bottom">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="100"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div v-else>
      <div class="detaildiv">
          <p class="detailTitle">
            {{detailObj.newsTitle}}
          </p>
      </div>
      <div class="updateTimeDiv">
          <span class="span">日期:{{detailObj.updateTime}}</span>
      </div>
      <p v-html="detailObj.newsContent"></p>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  components:{

  },
  props: {
    currentObj: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      navigationList: [],
      currentPage: 1,
      total: 0,
      seachObj: {
        pageNum: 1,
        pageSize: 10
      },
      newsList: [],
      detailShow: false,
      detailObj: {},
      langes: 0,
      barTitle:"",
      isShowTitle:false
    }
  },
  inject: ['parentEle'],
  watch: {
    currentObj: {
      deep: true,
      handler: function (val) {
        this.navigationList = JSON.parse(sessionStorage.getItem('pathList'))
        this.getNewsList(val.id);
        this.detailShow = false;
      }
    }
  },
  mounted() {
    this.langes = sessionStorage.getItem('watchStorage');
    window.addEventListener('setItem', () => {
      this.langes = sessionStorage.getItem('watchStorage');
    })
  },
  filters:{
       formatDateToMonth(time) {
        //let date = new Date(time)
         var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
         var timestr = Number(timearr[1])+ "-" + timearr[2];
         //timearr[0]+"年"+ 
        return timestr;
       },
        formatDateToYear(time) {
        //let date = new Date(time)
         var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
         var timestr = timearr[0];
        return timestr;
       },
       
  },
  methods: {
    handleCurrentChange(val) {

    },
     ellipsis: function(value) {
          //if (!value) return "";
          if (value.length > 40) {
            return value.slice(0, 40) + "...";
          }
          return value;
    },
    // 获取新闻列表
    getNewsList(val) {
      this.$api.get('api/web/get_news_page_list', {
        categoryId: val,
        ...this.seachObj
      }).then(res => {
        this.newsList = res.response.list;
        this.total = res.response.total;
      })
    },
    newsDetail(item) {
      this.detailObj = { ...item };
      this.barTitle =this.detailObj.newsTitle
      this.detailShow = true;
      this.isShowTitle = true
    },
    back(){
      this.detailShow = false;
       this.isShowTitle = false
    },
  }
}
</script>
<style scoped lang="less">
.baseNewsRight {
  width: calc(~"100% - 253px");
  background: white;
  float: right;
  .baseNewsTitle {
    height: 27px;
    padding-top: 6px;
    //background: url("http://www.worldelite.net.cn/data/templates/cn/img/title_bg.jpg") repeat-x;
    line-height: 27px;
    padding-left: 12px;
    color: #747575;
    text-align: left;
    & > span {
      color: #747575;
      cursor: pointer;
    }
    & > span:last-child {
      cursor: initial;
    }
    .contentTitle{
      font-size: 17px;
    }
  }
  .baseNewsContent {
    padding-top: 12px;
    padding-bottom: 12px;
    color: #706f6f;
    line-height: 1.8;
    overflow: auto;
    height: 650px;    
    li {
      display: flex;
      justify-content:flex-start;
      padding: 0 10px;
      height: 70px;
      padding-top: 10px;
      line-height: 30px;
      border-bottom: 1px solid #aeaead;
      color: #666666;
      padding-left: 31px;
      cursor: pointer;
      .timeDive{
         display: flex;
         justify-content:flex-start;
         flex-flow: column;
      }
      .createTime{
          font-size: 30px;
      }
      .createTimeYear{
        font-size: 15px;
        text-align: right;
      }
      .newsTitleSpan{
        padding-left: 20px;
        font-size: 20px;
      }
      .newsDetails{
        font-size: 12px;
        padding-left: 20px;
        padding-top: 0px;
        padding-bottom: 0px;
      }

    }
    .bottom {
      margin-top: 10px;
      display: flex;
      justify-items: center;
      justify-content: center;
      align-items: center;
    }
  }
  .detaildiv{
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .updateTimeDiv{
    border-left-width: 4px;
    border-left-color: #015EB7;
    border-left-style: solid;
    height: 30px;
    background:#44cef6;
    //opacity:0.1;
    .span {
      line-height: 28px;
      color: #333;
      font-weight: normal;
      padding-left: 10px;
    }
  }
  .detailTitle {
    display: block;
    font-size: 20px;
    color: #333;
    text-align: left;
    padding-bottom: 4px;
    line-height: 28px;

  }
}
</style>